"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerPinComponentSchema = void 0;
const zod_1 = require("zod");
const base_pin_component_1 = require("./base-pin-component");
const SpinnerSettingsSchema = base_pin_component_1.BasePinComponentSettingsSchema.merge(zod_1.z.object({
    backgroundColor: zod_1.z.string().optional(),
    options: zod_1.z.array(zod_1.z.string()).optional(),
}));
exports.SpinnerPinComponentSchema = base_pin_component_1.BasePinComponentSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('SPINNER'),
    settings: SpinnerSettingsSchema,
}));
//# sourceMappingURL=spinner-pin-component.js.map